import containers from '../containers/index';

export const baseUrl = '/main';

export const url = {
  WELCOME: `${baseUrl}/`,
  MODULE: `${baseUrl}/education-module`,
  IDENTIFY: `${baseUrl}/identify/a`,
  IDENTIFY_B: `${baseUrl}/identify/b`,
  IDENTIFY_C: `${baseUrl}/identify/c`,
  IDENTIFY_D: `${baseUrl}/identify/d`,
  IDENTIFY_E: `${baseUrl}/identify/e`,
  IDENTIFY_F: `${baseUrl}/identify/f`,
  ASSIST: `${baseUrl}/assist/a`,
  ASSIST_B: `${baseUrl}/assist/b`,
  ASSIST_C: `${baseUrl}/assist/c`,
  ASSIST_D: `${baseUrl}/assist/d`,
  ASSIST_E: `${baseUrl}/assist/e`,
  ASSIST_F: `${baseUrl}/assist/f`,
  ASSIST_G: `${baseUrl}/assist/g`,
  ASSIST_H: `${baseUrl}/assist/h`,
  ASSIST_I: `${baseUrl}/assist/i`,
  REFER: `${baseUrl}/refer/a`,
  REFER_B: `${baseUrl}/refer/b`,
  REFER_C: `${baseUrl}/refer/c`,
  REFER_D: `${baseUrl}/refer/d`,
  REFER_E: `${baseUrl}/refer/e`,
  REFER_F: `${baseUrl}/refer/f`,
  REFER_G: `${baseUrl}/refer/g`,
  REFER_H: `${baseUrl}/refer/h`,
  REFER_I: `${baseUrl}/refer/i`,
  REFERENCE: `${baseUrl}/quick-iar-reference-guide`,
  RESOURCES: `${baseUrl}/resources`,
  MENTAL: `${baseUrl}/mental-health-framework`,
  CONTACT_FORM: `${baseUrl}/contact-form`,
  CERTIFICATE: `${baseUrl}/certificate`,
  CASESTUDIES: `${baseUrl}/case-studies`,
  THANK_YOU: `${baseUrl}/thank-you`,
  TRAINING_COMPLETED: `${baseUrl}/training-completed`,
  PRE_QUESTIONNAIRE: `${baseUrl}/pre-questionnaire`,
  SITEMAP: `${baseUrl}/sitemap`
};

export const routes = [
  // Welcome
  {
    component: containers.Welcome,
    path: url.WELCOME
  },
  // Education Module
  {
    component: containers.Module,
    path: url.MODULE
  },
  // Identify
  {
    component: containers.IdentifyA,
    path: url.IDENTIFY
  },
  // IdentifyB
  {
    component: containers.IdentifyB,
    path: url.IDENTIFY_B
  },
  // IdentifyC
  {
    component: containers.IdentifyC,
    path: url.IDENTIFY_C
  },
  // IdentifyD
  {
    component: containers.IdentifyD,
    path: url.IDENTIFY_D
  },
  // IdentifyE
  {
    component: containers.IdentifyE,
    path: url.IDENTIFY_E
  },
  // IdentifyF
  {
    component: containers.IdentifyF,
    path: url.IDENTIFY_F
  },
  // AssistA
  {
    component: containers.AssistA,
    path: url.ASSIST
  },
  // AssistB
  {
    component: containers.AssistB,
    path: url.ASSIST_B
  },
  // AssistC
  {
    component: containers.AssistC,
    path: url.ASSIST_C
  },
  // AssistD
  {
    component: containers.AssistD,
    path: url.ASSIST_D
  },
  // AssistE
  {
    component: containers.AssistE,
    path: url.ASSIST_E
  },
  // AssistF
  {
    component: containers.AssistF,
    path: url.ASSIST_F
  },
  // AssistG
  {
    component: containers.AssistG,
    path: url.ASSIST_G
  },
  // AssistH
  {
    component: containers.AssistH,
    path: url.ASSIST_H
  },
  // AssistI
  {
    component: containers.AssistI,
    path: url.ASSIST_I
  },
  // Refer
  {
    component: containers.ReferA,
    path: url.REFER
  },
  // ReferB
  {
    component: containers.ReferB,
    path: url.REFER_B
  },
  // ReferC
  {
    component: containers.ReferC,
    path: url.REFER_C
  },
  // ReferD
  {
    component: containers.ReferD,
    path: url.REFER_D
  },
  // ReferE
  {
    component: containers.ReferE,
    path: url.REFER_E
  },
  // ReferF
  {
    component: containers.ReferF,
    path: url.REFER_F
  },
  // ReferG
  {
    component: containers.ReferG,
    path: url.REFER_G
  },
  // ReferH
  {
    component: containers.ReferH,
    path: url.REFER_H
  },
  // ReferI
  {
    component: containers.ReferI,
    path: url.REFER_I
  },
  // Resources
  {
    component: containers.Resources,
    path: url.RESOURCES
  },
  // IAR Reference Guide
  {
    component: containers.Reference,
    path: url.REFERENCE
  },
  // Mental Health
  {
    component: containers.Mental,
    path: url.MENTAL
  },
  // Contact Form
  {
    component: containers.ContactForm,
    path: url.CONTACT_FORM
  },
  // Certificate
  {
    component: containers.CertificatePage,
    path: url.CERTIFICATE
  },
  // Case Studies
  {
    component: containers.CaseStudies,
    path: url.CASESTUDIES
  },
  // Case Studies
  {
    component: containers.CaseStudiesQuestions,
    path: `${url.CASESTUDIES}/*`
  },
  // Thank You
  {
    component: containers.ThankYou,
    path: url.THANK_YOU
  },
  // TRAINING_COMPLETED
  {
    component: containers.TrainingCompleted,
    path: url.TRAINING_COMPLETED
  },
  // PRE_QUESTIONNAIRE
  {
    component: containers.PreQuestionnaire,
    path: url.PRE_QUESTIONNAIRE
  },
  // SITEMAP
  {
    component: containers.Sitemap,
    path: url.SITEMAP
  }
];



// WEBPACK FOOTER //
// ./src/constants/routes.jsx